// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import BurkinaFaso from '../_raw/flag/icon_flag_burkina_faso.png';

export default () => <img src={BurkinaFaso} alt="BurkinaFaso" />;
